import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryAreaTreeList, queryDepartTreeList, queryUserTreeList } from '@/api/api';
import MapLineString from '@/components/Map/MapLineString';
import pick from 'lodash.pick';
export default {
  name: 'PipeSystemModal',
  mixins: [ModalFormMixin],
  components: {
    MapLineString: MapLineString
  },
  data: function data() {
    return {
      title: '管网登记表单',
      tableName: 'env_pipe_system',
      siteName: '',
      form_fields: ['mn', 'title', 'category', 'userId', 'areaId', 'material', 'diameter', 'length', 'flow', 'slope', 'coordinate', 'status', 'sort', 'remark'],
      form_fields_time: [],
      areaTree: [],
      deptTree: [],
      userTree: [],
      validatorRules: {
        mn: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入责任人!'
          }]
        },
        areaId: {
          rules: [{
            required: true,
            message: '请输入行政区域!'
          }]
        },
        coordinate: {
          rules: [{
            required: true,
            message: '请输入坐标途径!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        sort: {
          rules: [{
            required: true,
            message: '请输入排序号!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loadTree();
  },
  methods: {
    add: function add(siteName) {
      this.siteName = siteName;
      this.edit();
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (typeof record != 'undefined') {
        this.siteId = this.model.siteId;
        this.siteName = this.model.paramName;
      } else this.model.siteId = this.siteId;

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    loadTree: function loadTree() {
      var _this2 = this;

      var that = this;
      that.deptTree = [];
      that.userTree = [];
      that.areaTree = []; // 区域

      queryAreaTreeList({
        status: '1'
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            temp.key = temp.key;
            that.areaTree.push(temp);
          }

          _this2.loading = false;
        }
      }); // 部门

      queryDepartTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.deptTree.push(temp);
          }

          _this2.loading = false;
        }
      }); // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    coordinateOk: function coordinateOk(value) {
      var that = this;

      if (value != null) {
        var a = '';
        value.forEach(function (element, index) {
          var b = '';
          element.forEach(function (item, i) {
            b += i == element.length - 1 ? item.join(',') : item.join(',') + '-';
          });
          a += index == value.length - 1 ? b : b + ':';
        });
        console.log(a, '抽屉2');
        this.form.setFieldsValue({
          coordinate: value ? a : null
        });
        this.model.coordinate = value ? a : null;
      }
    },
    coordinateChange: function coordinateChange() {
      console.log(this.model.coordinate);
      this.$refs.mapLine.show(this.model.coordinate);
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    }
  }
};